import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../app.model';
import { booleanLookup } from '../../../common/constants/common';
import { IDataRetentionLogState } from './dataRetentionLog.model';
import { searchDataRetentionLog } from './dataRetentionLog.action';

export const initialState: IDataRetentionLogState = {
  search: {
    loading: false,
    hasErrors: false,
    data: [],
    count: 0,
    lookups: {},
    tableName: '',
  },
  tableColumnSelection: {
    id: null,
    table_name: null,
    columns: {},
  },
};

export const dataRetentionLogSlice = createSlice({
  name: 'dataRetentionLog',
  initialState,
  reducers: {
    clearDataRetentionLog: () => {
      return initialState;
    },
    setTableColumnSelection: (state, action: PayloadAction<{ [key: string]: boolean }>) => {
      state.tableColumnSelection.columns = action.payload;
    },
  },
  extraReducers: {
    [searchDataRetentionLog.pending.type]: (state) => {
      state.search.loading = true;
    },
    [searchDataRetentionLog.fulfilled.type]: (state, action: PayloadAction<any>) => {
      const { records, total_count, table_name, column_selection } = action.payload;
      state.search.data = records;
      state.search.count = total_count;
      state.search.lookups = { booleanLookup };
      state.search.loading = false;
      state.search.hasErrors = false;
      state.search.tableName = table_name;
      if (column_selection) {
        state.tableColumnSelection.id = column_selection.id;
        const tableSelectionObj = JSON.parse(column_selection.columns as any);
        if (tableSelectionObj.columns) {
          state.tableColumnSelection.column_orders = tableSelectionObj.column_orders;
          state.tableColumnSelection.columns = tableSelectionObj.columns;
        } else {
          state.tableColumnSelection.columns = tableSelectionObj;
        }
      }
      state.tableColumnSelection.table_name = table_name;
    },
    [searchDataRetentionLog.rejected.type]: (state) => {
      state.search.loading = false;
      state.search.hasErrors = true;
    },
  },
});

// A selector
export const dataRetentionLogSelector = (state: RootState) => state.dataRetentionLog;

// Actions
export const { clearDataRetentionLog, setTableColumnSelection } = dataRetentionLogSlice.actions;

// The reducer
export default dataRetentionLogSlice.reducer;
